import { render, staticRenderFns } from "./MainCamsSetting.vue?vue&type=template&id=1f763f82"
import script from "./MainCamsSetting.vue?vue&type=script&lang=js"
export * from "./MainCamsSetting.vue?vue&type=script&lang=js"
import style0 from "./MainCamsSetting.vue?vue&type=style&index=0&id=1f763f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
